
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem2Grid extends Serenity.EntityGrid<PsAdvPromoItem2Row, any> {
        protected getColumnsKey() { return PsAdvPromoItem2Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem2Dialog; }
        protected getIdProperty() { return PsAdvPromoItem2Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem2Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem2Row.localTextPrefix; }
        protected getService() { return PsAdvPromoItem2Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}